import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import AddressControl from '../../form/AddressControl';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";
import {CurrencyFormatter, OptionFormatter} from "../../../utils/formatters";
import TextArea from "../../form/TextArea";
import Button from "../../form/Button";
import {postData} from "../../../utils/request";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {get} from "../../../utils/dotutils";
import ComponentField from "../../form/ComponentField";
import ComponentLoader from "../../form/ComponentLoader";
import Confirm from "../../form/Confirm";
import {isTrue} from "../../../utils/other";
import classNames from "classnames";
import Items from "src/components/editors/forms/Purchase/Items";

const LoyaltyPoints = (props) => {
    if (props?.values?.[props?.componentConfig?.idfield]) {
        return <ComponentLoader
            view={["amount","value"]}
            componentName="LoyaltyPointExchange"
            onFailure={() => null}
            filter={[{
                field: "exchange_type",
                value: props.componentConfig.componentname
            }, {
                field: "exchange_id",
                value: props.values[props.componentConfig.idfield]
            }]}
            componentAs="redeemed"
        >
            <LoyaltyPoint {...props} />
        </ComponentLoader>
    }
    return null;
}

const LoyaltyPoint = (props) => {
    if (props?.values?.[props?.componentConfig?.idfield]) {
        let loader = null;
        return <ComponentLoader
            ref={(el) => loader = el}
            view={["amount","credited"]}
            componentName="LoyaltyPoint"
            onFailure={() => null}
            filter={[{
                field: "source_type",
                value: props.componentConfig.componentname
            }, {
                field: "source_id",
                value: props.values[props.componentConfig.idfield]
            }]}
            componentAs="received"
        >
            <LoyaltyPointField {...props} refreshReceivedPoints={() => loader && loader.refresh()} />
        </ComponentLoader>
    }
    return null;
}

class LoyaltyPointField extends React.Component {
    state = {
        membercard: null
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.membercard + "" !== "" + prevProps.membercard) {
            this.setState({membercard: this.props.membercard})
        }
    }

    render() {
        return (
            <>
                <div className="row form-row">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <TextInput
                                    label="Beváltott törzsvásárlói pontok"
                                    value={this.props?.redeemed?.amount || 0}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-md-6">
                                <TextInput
                                    label={<Fragment>&nbsp;</Fragment>}
                                    value={this.props?.redeemed?.value || 0}
                                    formatter={CurrencyFormatter}
                                    disabled={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <label className="control-label">Kapott törzsvásárlói pontok</label>
                        <div className={classNames({"input-group": !isTrue(this.props?.received?.credited)})}>
                            <TextInput
                                label={false}
                                valid={isTrue(this.props?.received?.credited)}
                                value={this.props?.received?.amount || 0}
                                disabled={true}
                            />
                            {!isTrue(this.props?.received?.credited) && <div className="input-group-btn">
                                <Confirm
                                    header="Biztos"
                                    body="Biztos jóváírod neki a pontokat?"
                                    color="default"
                                    icon={{lib: "fas", name: "coins"}}
                                    tooltip="Pontok jóváírása"
                                    privileges={["credit_loyalty_points"]}
                                    privilegeVisible={true}
                                    onAccept={async () => {
                                        await this.props.processAction(async () => {
                                            const res = await postData({
                                                action: 'LoyaltyPointHandler.creditPoints',
                                                subject_component: {
                                                    component_type: this.props.componentConfig.componentname,
                                                    component_id: this.props.values[this.props.componentConfig.idfield]
                                                }
                                            });
                                            this.props.refreshReceivedPoints && this.props.refreshReceivedPoints();
                                            return res;
                                        })
                                    }}
                                />
                            </div>}
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    {/*Ha van vásárló vagy membercard, akkor nem lehet*/}
                    {!(this.props.values?.customer || this.props.values?.membercard) &&
                    <div className="col-md-4">
                        <label className="control-label">Törzsvásárlói kártya</label>
                        <div className="input-group">
                            <Select
                                {...this.props.getFieldProps("membercard")}
                                objectValue={false}
                                isClearable={true}
                                name="membercard"
                                component="membercard"
                                labelKey="barcode"
                                valueKey="id"
                                storeType="remote"
                                value={this.state.membercard}
                                saveChanges={(field, value)=>{this.setState({membercard: value})}}
                                label={false}
                            />
                            <div className="input-group-btn">
                                <Confirm
                                    header="Törzsvásárlói kártya hozzáadása"
                                    body="Biztos, hogy hozzá szeretnél adni egy törzsvásárlói kártyát ehhez a tranzakcióhoz? A vásárláshoz járó törzsvásárlói pontok is a kártyán lesznek."
                                    size="small"
                                    color="danger"
                                    acceptButton="Igen"
                                    disabled={(this.state.membercard + "" === "" + this.props.values?.membercard && !this.state.membercard) || this.props.isLoading}
                                    onAccept={async () => {
                                        await this.props.processAction(async () => {
                                            const res = await postData({
                                                action: "membercard.setPurchase",
                                                id: this.state.membercard,
                                                data: {
                                                    [this.props.componentConfig.idfield]: this.state.membercard,
                                                    purchase: this.props.values[this.props.componentConfig.idfield]
                                                }
                                            });
                                            this.props.refreshReceivedPoints && this.props.refreshReceivedPoints();
                                            return res;
                                        });
                                    }}
                                >
                                    <Button color={(this.state.membercard + "" === "" + this.props.values?.membercard && !this.state.membercard) || this.props.isLoading? "default" : "primary"}>
                                        Mentés
                                    </Button>
                                </Confirm>
                            </div>
                        </div>
                    </div>}
                </div>
            </>
        );
    }
}

class purchaseForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-2 col-md-push-10">
                        <TextInput
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                        />
                    </div>
                    <div className="col-sm-2 col-md-push-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="pid"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-3 col-md-pull-4">
                        <TextInput
                            {...this.props.getFieldProps("StockOperationState")}
                            disabled="disabled"
                            name="StockOperationState"
                            value={this.props.values.StockOperationState}
                            formatter={OptionFormatter}
                            label="Státusz"/>
                    </div>
                    <div className="col-sm-2 col-md-pull-4">
                        <DateTimeInput
                            {...this.props.getFieldProps("orderdate")}
                            name="orderdate"
                            disabled="disabled"
                            value={this.props.values.orderdate}
                            label="Rögzítés dátuma"
                            showTime={false}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-3 col-md-pull-4">
                        <label className="control-label">Elszámolás dátuma</label>
                        <div className="input-group">
                            <DateTimeInput
                                {...this.props.getFieldProps("transaction_date")}
                                name="transaction_date"
                                value={this.props.values.transaction_date}
                                label={false}
                                showTime={false}
                                disabled={this.props.values.state > 520 || this.props.isLoading}
                                saveChanges={this.props.setFieldValue}
                            />
                            <div className="input-group-btn">
                                <Button
                                    color={this.props.values.transaction_date === this.props.initialValues.transaction_date ? "default" : "primary"}
                                    disabled={this.props.values.transaction_date === this.props.initialValues.transaction_date || this.props.isLoading}
                                    onClick={async () => {
                                        await this.props.processAction(async () => {
                                            return await postData({
                                                action: this.props.componentConfig.componentname + '.update',
                                                data: {
                                                    [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                                                    transaction_date: this.props.values.transaction_date
                                                }
                                            });
                                        });
                                    }}>
                                    Mentés
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="pos"
                            label="Eladás helye"
                            disabled={true}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                        />
                    </div>
                </div>
                {this.props.partnerType === "customer" && <div className="row form-row">
                    <div className="col-md-6">
                        <Select
                            {...this.props.getFieldProps("agent")}
                            disabled={"disabled"}
                            objectValue={true}
                            name="agent"
                            component="user"
                            labelKey="name"
                            valueKey="id"
                            storeType="remote"
                            value={this.props.values.agent}
                            saveChanges={this.props.setFieldValue}
                            label="Vevő"
                        />
                    </div>
                    <div className="col-md-6">
                        <TextInput
                            {...this.props.getFieldProps("agent")}
                            disabled="disabled"
                            name="agent.telnum"
                            value={this.props.values.agent?.telnum}
                            label="Telefon"
                        />
                    </div>
                </div>}
                <div className="row form-row">
                    <div className="col-md-3">
                        <label className="control-label">Partner</label>
                        <Select
                            objectValue={true}
                            name={this.props.partnerType}
                            component="partner"
                            labelKey="name"
                            valueKey="partner_id"
                            storeType="remote"
                            view={["address","telnum"]}
                            value={this.props.values[this.props.partnerType]}
                            saveChanges={this.props.setFieldValue}
                            label={false}
                            disabled={this.props.editableFields.indexOf(this.props.partnerType) === -1}
                            {...this.props.getFieldProps(this.props.partnerType)}
                        />
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <AddressControl
                                disabled={"disabled"}
                                name={this.props.partnerType + ".address"}
                                value={(this.props.values[this.props.partnerType] || {}).address}
                                label="Cím"
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <TextInput
                            {...this.props.getFieldProps(this.props.partnerType)}
                            disabled="disabled"
                            name={this.props.partnerType + ".telnum"}
                            value={(this.props.values[this.props.partnerType] || {}).telnum}
                            label="Telefon"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <label className="control-label">Megjegyzés</label>
                        <div className="input-group comment">
                            <TextArea
                                {...this.props.getFieldProps("comment")}
                                name="comment"
                                value={this.props.values.comment}
                                label={false}
                                saveChanges={this.props.setFieldValue}
                            />
                            <div className="input-group-btn">
                                <Button
                                    color={this.props.values.comment === this.props.initialValues.comment ? "default" : "primary"}
                                    disabled={this.props.values.comment === this.props.initialValues.comment || this.props.isLoading}
                                    onClick={async () => {
                                        await this.props.processAction(async () => {
                                            return await postData({
                                                action: this.props.componentConfig.componentname + '.update',
                                                data: {
                                                    [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                                                    comment: this.props.values.comment
                                                }
                                            });
                                        });
                                    }}>
                                    Mentés
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.values.seller && <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <Select
                                {...this.props.getFieldProps("origin")}
                                name="origin"
                                component="location"
                                filter={{field: "partner", value: this.props.values.seller.partner_id}}
                                objectValue={true}
                                storeType="local"
                                value={this.props.values.origin}
                                label="Raktár"
                                disabled={this.props.editableFields.indexOf("origin") === -1}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                </div>}
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="control-label">Tételek</label>
                            <Items {...this.props} />
                        </div>
                    </div>
                </div>
                {this.props.componentConfig?.fielddefs?.vouchers ? <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="control-label">Utalványok</label>
                            <SelectorGrid
                                {...this.props.getFieldProps("vouchers")}
                                ref={(e) => this.vouchers = e}
                                className={"p-small-table"}
                                columns={{
                                    "displayname": {
                                        header: 'Utalvány',
                                        width: 3,
                                        sortable: true,
                                        filterable: true
                                    },
                                    "barcode": {
                                        header: 'Vonalkód',
                                        width: 3,
                                        sortable: true,
                                        filterable: true
                                    },
                                    "amount": {
                                        header: 'Összeg',
                                        width: 3,
                                        sortable: true,
                                        filterable: true,
                                        renderer: CurrencyFormatter
                                    },
                                }}
                                listfield="vouchers"
                                data={this.props.values}
                                orderBy={{field: "displayname", direction: "ASC"}}
                                componentConfig={this.props.componentConfig}
                            />
                        </div>
                    </div>
                </div> : null}
                {/*<LoyaltyPoints {...this.props} />*/}
            </form>
        );
    }
}

export default createForm(purchaseForm);
